export default __webpack_public_path__ + "static/media/vietnam-airline-logo.6d1bd3c5.jpg";